import React, {Component} from 'react';

import moment from 'moment';
import { CSSTransition } from 'react-transition-group';
import DatePicker from 'react-mobile-datepicker';

//controller
import MemberControllerAPI from '../../../controllers/API/MemberControllerAPI.js';
import ThanksControllerAPI from '../../../controllers/API/ThanksControllerAPI.js';

//validationSetting
import {validation} from '../../../static/js/settingFile/validationData.js';

import styles from '../../../static/css/articleStyleModules/tutorialArticle.module.scss';

import FaceIconBaseComponent from '../../faceIconComponents/FaceIconBaseComponent';
import MemberIconSelectComponent from '../inputComponent/MemberIconSelectComponent.js';
import ThanksButtonComponent from '../ThanksButtonComponent.js';

export default class TutorialArticle extends Component {

    constructor(props){
        super(props);
        this.state = {
            page:0,

            firstThanksData:{
                title:'',
                member_id:null,
                memo:'',
                date:new Date(),
                check:false,
            },

            memoTextLimit:validation.thanksMemoMax,

            firstMemberData:{
                name:'',
                memo:'',
                head:'basic',
                eyes:'basic',
                eyeblows:'basic',
                mouth:'basic',
                face_ex:'',
                color:'hsl(6,77%,62%)',
                order:null,
                twitter_id:'',
            },

            thanksCheckStatusDisplay:'↑ハートをタップ！',

            datePickerIsOpen:false,
            iconSelectModalIsOpen:false,
          }
    }

    firstAccessFinished = () => {
        localStorage.firstAccess = false;
    }


    goToPrevPage = () => {
        if(this.state.page === 0){
            return
        }else{
            const prevPage = this.state.page - 1;
            this.setState({page:prevPage})

            process.nextTick(() => {
                this.refs.mainArea.scrollTop = 0;
            })

        }
    }

    goToNextPage = () => {
        if(this.state.page >= this.state.lastPage ){
            return
        }else{
            //validate
            if(this.state.page === 0 && this.state.firstThanksData.title === ''){
                this.props.onInfoDispShow('cancel','hsl(6,77%,62%)','どんなこと？\nを記入してください')
                return;
            }
            if(this.state.page === 1 && this.state.firstThanksData.memo.length > this.state.memoTextLimit){
                this.props.onInfoDispShow('cancel','hsl(6,77%,62%)','文字数オーバーです')
                return;
            }

            const nextPage = this.state.page + 1;
            this.setState({page:nextPage});

            process.nextTick(() => {
                this.refs.mainArea.scrollTop = 0;
            })
        }
    }

    datePickedHandleSelect = (time) => {
        let copyToOverWrite = JSON.parse(JSON.stringify(this.state.firstThanksData));
        copyToOverWrite.date = time;      
        this.setState({firstThanksData:copyToOverWrite, datePickerIsOpen:false});
    }

    datePickedHandleCancel = () => {
        this.setState({datePickerIsOpen:false});
    }


    changeThanksTitle = (event) => {
        const escapedDate = this.state.firstThanksData.date;
        let copyToOverWrite = JSON.parse(JSON.stringify(this.state.firstThanksData));
        copyToOverWrite.title = event.target.value;      
        copyToOverWrite.date = escapedDate;      
        this.setState({firstThanksData:copyToOverWrite});
    }

    changeMemberName = (event) => {
        let copyToOverWrite = JSON.parse(JSON.stringify(this.state.firstMemberData));
        copyToOverWrite.name = event.target.value;      
        this.setState({firstMemberData:copyToOverWrite});
    }

    changeIconData = (newHead,newEyes,newEyeblows,newMouth,newColor) => {
        let memberDataToRewrite = this.state.firstMemberData;
        memberDataToRewrite.head = newHead;
        memberDataToRewrite.eyes = newEyes;
        memberDataToRewrite.eyeblows = newEyeblows;
        memberDataToRewrite.mouth = newMouth;
        memberDataToRewrite.color = newColor;
        this.setState({memberDataForEdit:memberDataToRewrite,iconSelectModalIsOpen:false});
    }

    changeThanksMemo = (event) => {
        const escapedDate = this.state.firstThanksData.date;
        let copyToOverWrite = JSON.parse(JSON.stringify(this.state.firstThanksData));
        copyToOverWrite.memo = event.target.value;      
        copyToOverWrite.date = escapedDate;      
        this.setState({firstThanksData:copyToOverWrite});
    }

    changeThanksCheck = (newData) => {
        this.setState({firstThanksData:newData});
        if(this.state.firstThanksData.check){
          this.setState({thanksCheckStatusDisplay:'した！'})
        }else{
          this.setState({thanksCheckStatusDisplay:'まだ…'})
        }
    }

    submitTutorial = () => {
        if(this.state.firstMemberData.name !== ''){
            MemberControllerAPI.store(this.state.firstMemberData)
            .then((result) => {
                
                const newMemberId = result.data.id;

                this.postNewThanks(newMemberId)
                .then((result) => {
                    this.endTutorial();
                    this.firstAccessFinished();
                })
            })
            .catch((error) => {
                console.log(error.message);
            })
        }else{
            this.postNewThanks(null)
            .then((result) => {
                this.endTutorial();
                this.firstAccessFinished();
            })
        }
    }

    postNewThanks = (memberId) => {

        return new Promise((resolve,reject) => {
            //memberIdをセット
            let thnaksToPost = this.state.firstThanksData;
            thnaksToPost.member_id = memberId;

            ThanksControllerAPI.store(thnaksToPost)
            .then((result) => {
                resolve()
            })
            .catch((error) => {
                console.log(error.message);
                reject()
            })        
        })
    }

    endTutorial = () => {
        this.props.onInfoDispShow('facedHeart','hsl(6,77%,62%)','保存しました！')
        this.props.onEndTutorial();
    }


    render() {

        const thanksDate = (dateIntStr) => {
            if(dateIntStr !== undefined){
                const dateString = moment(dateIntStr).format('YYYY年MM月DD日')
                
                return dateString;
            }else{
                return '';
            }
        }
        const haveYouHadAnyThanks = (
            <div className={styles['pageArea']} 
            key="haveYouHadAnyThanks">
              <h2>「ありがとう」と思ったことを<br></br>教えてください</h2>
              <h3>最近ありがとうと思ったのはどんなこと？<br></br>いままでの人生で一番感謝していることは？</h3>
              <h4>いつ？</h4>
              <div className={styles['dateButton'] + ' thanksLogButton touchActiveDark'}
              onClick={() => {this.setState({datePickerIsOpen:true})}}>
                {thanksDate(this.state.firstThanksData.date)}
              </div>
              <h4>どんなこと？</h4>
              <input type="text" className="thanksLogInput"
              onChange={this.changeThanksTitle}
              value={this.state.firstThanksData.title}
              placeholder="例：お菓子をくれた"
              maxLength={validation.thanksTitleMax}
              />
              <h4>誰に？</h4>
              <input type="text" className="thanksLogInput"
              onChange={this.changeMemberName}
              value={this.state.firstMemberData.name}
              placeholder="名前を入力してください"
              maxLength="16"
              />
              {/* iOS has error with scroll in changing height */}
              <div 
              // className={
              //   (this.state.firstMemberData.name === '' 
              //   ? styles['iconSelectArea'] + ' ' + styles['isHidden'] : styles['iconSelectArea'])
              className={styles['iconSelectArea']}
              >
                <h4>どんなひと？</h4>
                <div className={styles['iconButton'] + ' thanksLogButton touchActiveDark'}
                onClick={ () => { this.setState( {iconSelectModalIsOpen:true} ) } }
                >
                  <FaceIconBaseComponent
                  head={this.state.firstMemberData.head}
                  eyes={this.state.firstMemberData.eyes}
                  eyeblows={this.state.firstMemberData.eyeblows}
                  mouth={this.state.firstMemberData.mouth}
                  fillColor={this.state.firstMemberData.color}
                  />
                </div>
              </div>
              <div className={
                  this.state.firstThanksData.title !== ''
                  ? styles['pageButton'] + ' touchActiveDark'
                  : styles['pageButton'] + ' ' + styles['disable']
              }
              onClick={() => this.goToNextPage()}
              >つぎへ</div>

              <CSSTransition
              in={this.state.datePickerIsOpen}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <DatePicker 
                value={this.state.firstThanksData.date}
                isOpen={this.state.datePickerIsOpen}
                min={new Date(1, 0, 1)} 
                max={new Date(2100, 0, 1)} 
                confirmText={'OK'}
                cancelText={'キャンセル'}
                onSelect={this.datePickedHandleSelect}
                onCancel={this.datePickedHandleCancel}
                />
              </CSSTransition>

            </div>
        )

        const textMaxedOutStyle = () => {
            if(this.state.firstThanksData.memo.length > this.state.memoTextLimit){
                return {color:'hsl(6,77%,62%)',transition:'color .2s'}
            }else{
                return {color:'#999999',transition:'color .2s'};
            }
        }

        const howDidYouFeel = (
            <div className={styles['pageArea']} 
            key="howDidYouFeel">
              <h2>そのとき<br/>どんなことを感じましたか？</h2>
              <h3>嬉しかった気持ちや<br/>憶えておきたいことなど<br/>なんでもメモしてみてください</h3>
              <textarea className={'thanksLogInput'}
              onChange={this.changeThanksMemo}
              value={this.state.firstThanksData.memo}
              rows="6"
              placeholder="例：もらったお菓子がすごくおいしかった！ちょうどお腹がすいていたのでうれしかった！"
              />
              <div className={styles['textCounter']} style={textMaxedOutStyle()}>
                <span>{this.state.firstThanksData.memo.length}</span>
                <span> / </span>
                <span>{this.state.memoTextLimit}</span>
              </div>
              <div className={styles['buttonFlexArea']}>
                <div className={styles['pageButton'] + ' touchActiveDark'}
                onClick={() => this.goToPrevPage()}
                >もどる</div>
                <div className={
                    this.state.firstThanksData.memo.length <= this.state.memoTextLimit
                    ? styles['pageButton'] + ' touchActiveDark'
                    : styles['pageButton'] + ' ' + styles['disable']
                }
                onClick={() => this.goToNextPage()}
                >つぎへ</div>
              </div>
            </div>
        )

        const haveYouToldThankYou = (
            <div className={styles['pageArea']} 
            key="haveYoySaidThankYou">
              <h2>そのひとに<br/>「ありがとう」<br/>を伝えましたか？</h2>
              <div className={styles['thanksCheckButton']}>
                <ThanksButtonComponent
                thankData={this.state.firstThanksData}
                type={'round'}
                status={this.state.firstThanksData.check}
                onRewriteBackData={(newData) => this.changeThanksCheck(newData)}
                dataSending={false}
                />
              </div>
              <div className={styles['thanksCheckStatusDisplay']}>
                {this.state.thanksCheckStatusDisplay}
              </div>
              <div className={styles['buttonFlexArea']}>
                <div className={styles['pageButton'] + ' touchActiveDark'}
                onClick={() => this.goToPrevPage()}
                >もどる</div>
                <div className={
                    this.state.firstThanksData.memo.length <= this.state.memoTextLimit
                    ? styles['pageButton'] + ' touchActiveDark'
                    : styles['pageButton'] + ' ' + styles['disable']
                }
                onClick={() => this.submitTutorial()}
                >ログ！</div>
              </div>
            </div>
        )

        const pageComponentArray = [
            // thankYouPage,
            haveYouHadAnyThanks,
            howDidYouFeel,
            haveYouToldThankYou,
        ]
        

        return (
          <div>

            <div className={styles['tutorialArticleArea']} ref="mainArea">
              {pageComponentArray.map((value,index) => {
                  return (
                      <CSSTransition
                      in={this.state.page === index}
                      timeout={200}
                      classNames="simpleFadeIn200"
                      unmountOnExit
                      mountOnEnter
                      key={index}
                      >
                        {value}
                      </CSSTransition>
                  )
              })}
            </div>

            {/* ここに置いておかないとiOSでoverflowの関係でバグる */}
            <CSSTransition
            in={this.state.iconSelectModalIsOpen}
            timeout={200}
            classNames="simpleFade200"
            unmountOnExit
            mountOnEnter
            >
              <div className={styles['iconSelectModalBase']}>
                <div className={styles['iconSelectModal']}>
                  <MemberIconSelectComponent 
                  memberData={this.state.firstMemberData}
                  onEnterClick={this.changeIconData}
                  onCancelClick={() => {this.setState({iconSelectModalIsOpen:false})}} />
                </div>
              </div>
            </CSSTransition>

          </div>

        )
    }

};